import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Title, ActionHeaderContainer } from "./ActionHeaderStyles.js";
import { StatusBadge } from "../../reusableComponents/StatusBadge/index.js";
import { Chevron } from "../../reusableComponents/Chevron/index.js";

const ActionHeader = ({ productName, status, isOpen }) => {
  const Icon = useMemo(() => <StatusBadge status={status} />, [status]);

  return (
    <ActionHeaderContainer>
      <Chevron isOpen={isOpen} />
      <Title>{productName}</Title>
      {Icon}
    </ActionHeaderContainer>
  );
};
ActionHeader.propTypes = {
  productName: PropTypes.string.isRequired,
  status: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
export default ActionHeader;
